import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {Translate} from 'react-redux-i18n';
import {useLocation} from 'react-router-dom';

import {useStateHook} from 'front-onceforall-core/dist/utils/customHooks';

import {captureError} from '../../../../utils/log';
import * as snackbarsActions from '../../../../actions/snackbars';

import {getSubscriptionData, getPlanData, getNumberOfActiveClients} from './utils';
import DetailsView from './DetailsView';

function DetailsContainer() {
  const organisation = useSelector(globalState => globalState.organisation);
  const dispatch = useDispatch();
  const {pathname} = useLocation();
  const [state, setState] = useStateHook({
    loading: true,
    subscription: null
  });

  function getActiveSubscriptionDetails(organisationId) {
    if (!organisationId) { return; }
    setState({loading: true});

    Promise.all([
      getPlanData(organisationId),
      getSubscriptionData(organisationId),
      getNumberOfActiveClients(organisation)
    ]).then(([ofaPlan, currentSubscription, nbClients]) => {
      // Display only subscription details if it is an OFA plan
      if (currentSubscription && ofaPlan) {
        setState({subscription: {
          ...currentSubscription,
          upgradable: ofaPlan.upgradable,
          nbClients
        }});
      }
    }).catch(error => {
      captureError('Error while loading subscription details', error);
      dispatch(snackbarsActions.addError(<Translate value="error.generic"/>));
    }).finally(() => {
      setState({loading: false});
    });
  }

  React.useEffect(() => {
    getActiveSubscriptionDetails(organisation?.organisationId);
  }, [organisation?.organisationId]);

  return (
    <DetailsView
      pathname={pathname}
      loading={state.loading}
      subscription={state.subscription}
    />
  );
}

export default DetailsContainer;
